import store from '@/store'

export default {
	install(Vue) {
		Vue.prototype.$utils = {
			// 全局方法
			checkPermission(value) {
				let roles = [];
				const opers = store.getters['log/permissionLists'];
				const menus = store.getters['log/menuPermissionLists'];
				roles = [...opers, ...menus];
				if (value && value instanceof Array) {
					if (value.length > 0) {
						const permissionRoles = value

						const hasPermission = roles.some(role => {
							return permissionRoles.includes(role)
						})
						return hasPermission
					}
				} else {
					throw new Error(`need roles! Like v-permission="['admin','editor']"`)
				}
			}
		}
	}
}
